import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessDataProperty } from './process-data-property';
export { ProcessDataProperty };
import { processDataPropertySchema } from '@schemas/business-objects/process-data-property';
import { ProcessDataTypeFormGroup } from './process-data-type-form-group';

export class ProcessDataPropertyFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    isArray: SchemaFormControl;
    description: SchemaFormControl;
    sequence: SchemaFormControl;
    dataTypeId: SchemaFormControl;
    dataType: ProcessDataTypeFormGroup;
    typeId: SchemaFormControl;
    type: ProcessDataTypeFormGroup;
  };

  declare value: Partial<ProcessDataProperty>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processDataPropertySchema, ProcessDataProperty, data, options);
  }

  get object(): ProcessDataProperty {
    return new ProcessDataProperty(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'dataType':
        return new ProcessDataTypeFormGroup();
      case 'type':
        return new ProcessDataTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessDataProperty[]> {
    return ProcessDataProperty.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessDataProperty | null> {
    return ProcessDataProperty.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessDataProperty> {
    return ProcessDataProperty.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessDataProperty>,
  ): Promise<ProcessDataProperty> {
    return ProcessDataProperty.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessDataProperty>,
  ): Promise<ProcessDataProperty> {
    return ProcessDataProperty.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessDataProperty.deleteById(id);
  }
}

export class ProcessDataPropertyFormArray extends PersistedFormArray {
  declare controls: ProcessDataPropertyFormGroup[];

  readonly entityName = 'ProcessDataProperty' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processDataPropertySchema, ProcessDataProperty, options);
  }

  protected override createItemGroup() {
    return new ProcessDataPropertyFormGroup();
  }

  get array(): ProcessDataProperty[] {
    return this.controls.map(
      (group: ProcessDataPropertyFormGroup) => group.object,
    );
  }
}

export class ProcessDataPropertyPersistedArray extends PersistedArray<ProcessDataProperty> {
  readonly entityName = 'ProcessDataProperty' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessDataProperty, options);
  }
}
